import Vue from 'vue'

async function checkAuth() {
    if (Vue.$cookies.get("authToken")) {
        let authToken = Vue.$cookies.get("authToken");
        try {
            let response = await fetch(Vue.prototype.$apiUrl + "/reAuth", {
                method: "POST",
                body: JSON.stringify(authToken),
            });
            let responseData = await response.json();

            if (responseData.state) {
                Vue.$cookies.set("authToken", responseData.authToken);
                if (Vue.prototype.$dev) {
                    console.log(JSON.stringify(responseData.authToken))
                }
                return { state: true, msg: "authed" };
            }
        } catch (e) {
            console.log(e)
            let Notify = {
                duration: 4000,
                type: "error",
                headline: "Spotify-Login",
                message: "Failed to login! Try again later...",
            };
            Vue.prototype.$globalState.addNotification(Notify);
            return { state: false, msg: "no-connection" }
        }


    }
    return { state: false, msg: "auth-needed" };
}

async function checkUserProfile() {
    if (!Vue.prototype.$globalState.userProfile.name) {

        let authToken = Vue.$cookies.get("authToken")
        let payload = {
            authToken: authToken
        }
        try {
            let response = await fetch(Vue.prototype.$apiUrl + "/data/userProfile", {
                method: "POST",
                body: JSON.stringify(payload)
            })

            let responseData = await response.json()


            if (responseData.state) {
                Vue.prototype.$globalState.userProfile = responseData.userProfile
                return { state: true, msg: "Fetched profile" };
            }
        } catch (e) {
            console.log(e)
            let Notify = {
                duration: 4000,
                type: "error",
                headline: "Spotify-Login",
                message: "Failed to login! Try again later...",
            };
            Vue.prototype.$globalState.addNotification(Notify);
            return { state: false, msg: "no-connection" }
        }
    }
    return { state: true, msg: "Store existed" }

}

async function checkUserPlaylists() {
    if (Vue.prototype.$globalState.userPlaylists.length === 0) {

        let authToken = Vue.$cookies.get("authToken")
        let payload = {
            authToken: authToken
        }
        try {
            let response = await fetch(Vue.prototype.$apiUrl + "/data/userPlaylists", {
                method: "POST",
                body: JSON.stringify(payload)
            })

            let responseData = await response.json()


            if (responseData.state) {
                Vue.prototype.$globalState.userPlaylists = responseData.userPlaylists
                Vue.prototype.$globalState.listify = responseData.listify
                return { state: true, msg: "Fetched playlists" };
            }
        } catch (e) {
            console.log(e)
            let Notify = {
                duration: 4000,
                type: "error",
                headline: "Spotify-Login",
                message: "Failed to login! Try again later...",
            };
            Vue.prototype.$globalState.addNotification(Notify);
            return { state: false, msg: "no-connection" }
        }
    }
    return { state: true, msg: "Store existed" }
}

export { checkAuth, checkUserProfile, checkUserPlaylists }